/* Live Free — the Ingredient Index (BUILD-07 §1). Built to `Ingredient Index.dc.html`.
   No dependencies. Everything below the tool head is progressive: the page ships
   the first sixty entries as plain links, and this script takes over once the
   JSON feed (?view=lf-glossary-data) has been fetched — on first interaction,
   or on idle after load when the section says so and the connection is not
   metered. Verdict keys are the six on the lf_ingredient definition. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lf-glossary]');
  if (!root) return;

  var ORDER = ['never-allowed', 'safe-comedogenic', 'depends-on-dose', 'allowed', 'cleaner-choice', 'we-look-for-this'];
  var POSITIVE = { 'we-look-for-this': 1, 'cleaner-choice': 1 };
  var VERD = readJSON('[data-lf-verdicts]') || {};
  var T = readJSON('[data-lf-i18n]') || {};
  var CAP = Math.max(50, parseInt(root.getAttribute('data-lf-cap'), 10) || 400);
  var SORT = root.getAttribute('data-lf-sort') || 'verdict';
  var FEED = root.getAttribute('data-lf-feed');
  var ASSET = root.getAttribute('data-lf-asset') || '';
  var TOTAL = parseInt(root.getAttribute('data-lf-total'), 10) || 0;
  var EXAMPLE = root.getAttribute('data-lf-example') || '';
  var AGES = String(T.ages || '').split('|').map(trim).filter(Boolean);
  var MORE = [
    ['avoid', function (it) { return !!it.pr; }],
    ['nonco', function (it) { return !it.pr && it.v !== 'never-allowed'; }],
    ['catalog', function (it) { return it.p.length > 0; }],
    ['written', function (it) { return it.d === 'written'; }]
  ];

  var el = {
    tabs: root.querySelectorAll('[data-lf-tab]'),
    panels: root.querySelectorAll('[data-lf-panel]'),
    q: root.querySelector('[data-lf-q]'),
    count: root.querySelector('[data-lf-count]'),
    clear: root.querySelector('[data-lf-clear]'),
    facets: root.querySelector('[data-lf-facets]'),
    groups: root.querySelector('[data-lf-facet-groups]'),
    status: root.querySelector('[data-lf-status]'),
    list: root.querySelector('[data-lf-list]'),
    capped: root.querySelector('[data-lf-capped]'),
    label: root.querySelector('[data-lf-label]'),
    labelClear: root.querySelector('[data-lf-label-clear]'),
    labelReset: root.querySelector('[data-lf-label-reset]'),
    vbox: root.querySelector('[data-lf-vbox]'),
    vhead: root.querySelector('[data-lf-vhead]'),
    vsub: root.querySelector('[data-lf-vsub]'),
    crows: root.querySelector('[data-lf-crows]'),
    cempty: root.querySelector('[data-lf-cempty]'),
    cunmatched: root.querySelector('[data-lf-cunmatched]')
  };

  var S = {
    data: null, loading: null, error: null,
    mode: 'browse', q: '', open: null,
    sel: { verdict: [], function: [], good: [], skin: [], age: [], more: [] }
  };

  /* ---------- helpers ---------- */
  function readJSON(sel) { var n = root.querySelector(sel); try { return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; } }
  function trim(s) { return String(s).trim(); }
  function h(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function fmt(s, map) { return String(s || '').replace(/\[(\w+)\]/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
  function num(n) { return Number(n).toLocaleString('en-US'); }
  function handle(n) { return String(n).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function norm(n) { return String(n).toLowerCase().replace(/\([^)]*\)/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function isAny(v) { return /^any\b/i.test(v); }
  function chip(key, size) { var c = h('span', 'lf-chip lf-chip--' + key + ' lf-chip--' + (size || 'md'), VERD[key] || key); return c; }
  function badge(label, tone) { return h('span', 'lf-gbadge' + (tone ? ' lf-gbadge--' + tone : ''), label); }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); var a = arguments, c = this; t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  /* ---------- data ---------- */
  function load() {
    if (S.data) return Promise.resolve();
    if (S.loading) return S.loading;
    setStatus(fmt(T.loading, { t: num(TOTAL) }), '');
    S.loading = fetchPage(1).then(function (first) {
      /* The storefront feed is live from admin but Shopify's metaobject paginate caps at 1000
         and ignores ?page=. The theme asset (written by the import) supplies whatever the feed
         could not reach; a live entry always wins over its asset copy. */
      var need = (first.meta.total || 0) > first.items.length;
      var tail = need && ASSET ? fetch(ASSET, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { items: [] }; }).catch(function () { return { items: [] }; }) : Promise.resolve({ items: [] });
      return tail.then(function (extra) {
        var items = first.items.slice(), seen = {};
        items.forEach(function (it) { seen[it.h || handle(it.n)] = 1; });
        (extra.items || []).forEach(function (it) { if (!seen[it.h]) items.push(it); });
        items.forEach(prep);
        S.data = items;
        S.loading = null;
        setStatus('', '');
        onData();
      });
    }).catch(function () {
      S.loading = null;
      setStatus(T.error, 'error');
    });
    return S.loading;
  }
  function fetchPage(p) {
    return fetch(FEED + '&page=' + p, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (txt) { return JSON.parse(txt); });
  }
  function prep(it) {
    it.a = it.a || []; it.f = it.f || []; it.g = it.g || []; it.s = it.s || []; it.b = it.b || []; it.p = it.p || []; it.src = it.src || [];
    it._h = it.h || handle(it.n);
    it._blob = (it.n + ' ' + it.a.join(' ') + ' ' + (it.w || '')).toLowerCase();
    it._norms = [norm(it.n)].concat(it.a.map(norm));
  }
  function onData() {
    var pager = el.list.querySelector('[data-lf-pager]');
    if (pager) pager.remove();
    el.facets.hidden = false;
    var entry = new URLSearchParams(location.search).get('entry');
    if (entry) { var hit = S.data.filter(function (x) { return x._h === entry; })[0]; if (hit) { S.open = hit._h; if (!S.q) { S.q = hit.n; el.q.value = hit.n; } } }
    renderBrowse();
    renderCheck();
  }
  function setStatus(text, kind) {
    el.status.textContent = text || '';
    el.status.className = 'lf-gstatus' + (kind ? ' lf-gstatus--' + kind : '');
    el.status.hidden = !text;
  }

  /* ---------- filtering ---------- */
  function pass(it, sel, q, skip) {
    if (q && it._blob.indexOf(q) === -1) return false;
    if (skip !== 'verdict' && sel.verdict.length && sel.verdict.indexOf(it.v) === -1) return false;
    if (skip !== 'function' && sel.function.length && !sel.function.some(function (v) { return it.f.indexOf(v) > -1; })) return false;
    if (skip !== 'good' && sel.good.length && !sel.good.some(function (v) { return it.g.indexOf(v) > -1; })) return false;
    if (skip !== 'skin' && sel.skin.length && !sel.skin.some(function (v) { return it.s.indexOf(v) > -1 || it.s.some(isAny); })) return false;
    if (skip !== 'age' && sel.age.length && !sel.age.some(function (v) { return it.b.indexOf(v) > -1; })) return false;
    if (skip !== 'more' && sel.more.length) {
      for (var i = 0; i < sel.more.length; i++) { var m = MORE.filter(function (x) { return x[0] === sel.more[i]; })[0]; if (m && !m[1](it)) return false; }
    }
    return true;
  }
  function anyFilter() { return !!(S.q || Object.keys(S.sel).some(function (k) { return S.sel[k].length; })); }
  function toggle(group, val) {
    var cur = S.sel[group], i = cur.indexOf(val);
    if (i > -1) cur.splice(i, 1); else cur.push(val);
    renderBrowse();
  }
  function union(getter) {
    var tally = {};
    S.data.forEach(function (it) { getter(it).forEach(function (v) { if (!isAny(v)) tally[v] = (tally[v] || 0) + 1; }); });
    return Object.keys(tally).sort(function (a, b) { return tally[b] - tally[a] || a.localeCompare(b); });
  }
  var VALS = null;
  function groupDefs() {
    if (!VALS) VALS = {
      good: union(function (it) { return it.g; }),
      fn: union(function (it) { return it.f; }),
      skin: union(function (it) { return it.s; })
    };
    var skinAll = VALS.skin;
    return [
      ['verdict', T.groups.verdict, ORDER.map(function (k) { return [k, VERD[k] || k]; }), function (it) { return [it.v]; }],
      ['good', T.groups.good, VALS.good.map(function (v) { return [v, v]; }), function (it) { return it.g; }],
      ['function', T.groups.function, VALS.fn.map(function (v) { return [v, v]; }), function (it) { return it.f; }],
      ['skin', T.groups.skin, skinAll.map(function (v) { return [v, v]; }), function (it) { return it.s.some(isAny) ? skinAll : it.s; }],
      ['age', T.groups.age, AGES.map(function (v) { return [v, v]; }), function (it) { return it.b; }],
      ['more', T.groups.more, MORE.map(function (m) { return [m[0], T.more[m[0]]]; }), function (it) { return MORE.filter(function (m) { return m[1](it); }).map(function (m) { return m[0]; }); }]
    ];
  }

  /* ---------- browse render ---------- */
  function renderBrowse() {
    if (!S.data) return;
    var q = S.q.trim().toLowerCase(), sel = S.sel;
    // facets, each counted against every other group
    var frag = document.createDocumentFragment();
    groupDefs().forEach(function (gd) {
      var key = gd[0], label = gd[1], vals = gd[2], getter = gd[3];
      var pool = S.data.filter(function (it) { return pass(it, sel, q, key); });
      var tally = {};
      pool.forEach(function (it) { getter(it).forEach(function (v) { tally[v] = (tally[v] || 0) + 1; }); });
      var pills = vals.map(function (pair) { return { val: pair[0], label: pair[1], count: tally[pair[0]] || 0, active: sel[key].indexOf(pair[0]) > -1 }; });
      if (key !== 'age') pills = pills.filter(function (p) { return p.count > 0 || p.active; });
      if (!pills.length) return;
      var g = h('div', 'lf-gfacet');
      g.appendChild(h('p', 'lf-gfacet__label', label));
      var row = h('div', 'lf-gfacet__pills');
      pills.forEach(function (p) {
        var b = h('button', 'lf-gpill'); b.type = 'button'; b.setAttribute('aria-pressed', p.active ? 'true' : 'false');
        b.appendChild(h('span', null, p.label)); b.appendChild(h('span', 'lf-gpill__n', num(p.count)));
        b.addEventListener('click', function () { toggle(key, p.val); });
        row.appendChild(b);
      });
      g.appendChild(row); frag.appendChild(g);
    });
    el.groups.textContent = ''; el.groups.appendChild(frag);

    // the list
    var filtered = S.data.filter(function (it) { return pass(it, sel, q, null); });
    filtered.sort(function (a, b) {
      if (SORT !== 'alphabetical') {
        var d = ORDER.indexOf(a.v) - ORDER.indexOf(b.v); if (d) return d;
        if (a.d !== b.d) return a.d === 'written' ? -1 : 1;
      }
      return a.n.localeCompare(b.n);
    });
    var shown = filtered.slice(0, CAP);
    var lf = document.createDocumentFragment();
    shown.forEach(function (it) { lf.appendChild(row(it)); });
    el.list.textContent = ''; el.list.appendChild(lf);

    el.count.textContent = anyFilter() ? fmt(T.count, { n: num(filtered.length), t: num(S.data.length) }) : fmt(T.countOnly, { n: num(S.data.length) });
    el.clear.hidden = !anyFilter();
    if (!filtered.length) setStatus(T.empty, 'empty'); else if (!S.error) setStatus('', '');
    el.capped.hidden = filtered.length <= CAP;
    el.capped.textContent = fmt(T.capped, { n: num(CAP), m: num(filtered.length) });
    syncURL();
  }

  function row(it) {
    var open = S.open === it._h;
    var art = h('article', 'lf-grow lf-grow--' + it.v + (open ? ' lf-grow--open' : ''));
    var btn = h('button', 'lf-grow__btn'); btn.type = 'button'; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var top = h('span', 'lf-grow__top'); top.appendChild(h('span', 'lf-grow__name', it.n)); top.appendChild(chip(it.v, 'md')); btn.appendChild(top);
    if (it.a.length) btn.appendChild(h('span', 'lf-grow__aka', it.a.join(' · ')));
    if (it.w) btn.appendChild(h('span', 'lf-grow__desc', it.w));
    var badges = [];
    it.g.slice(0, 3).forEach(function (g) { badges.push(badge(g.toLowerCase(), 'lime')); });
    if (it.pr === 'mod' || it.pr === 'high') badges.push(badge(T.badges.clog, 'gold'));
    if (it.c) badges.push(badge(it.c.length > 34 ? T.badges.range : it.c, 'gold'));
    if (it.st) badges.push(badge(T.badges.stacking, 'plum'));
    if (it.p.length) badges.push(badge(fmt(T.badges.inours, { n: it.p.length })));
    if (it.pc) badges.push(badge(fmt(T.badges.partof, { c: it.pc.toLowerCase() })));
    if (it.lh === 'banned') badges.push(badge(T.badges.lh));
    if (badges.length) { var br = h('span', 'lf-grow__badges'); badges.forEach(function (b) { br.appendChild(b); }); btn.appendChild(br); }
    btn.addEventListener('click', function () {
      var was = S.open === it._h; S.open = was ? null : it._h;
      var prev = el.list.querySelector('.lf-grow--open');
      if (prev && prev !== art) { prev.classList.remove('lf-grow--open'); prev.querySelector('.lf-grow__btn').setAttribute('aria-expanded', 'false'); var pd = prev.querySelector('.lf-gdetail'); if (pd) pd.remove(); }
      art.classList.toggle('lf-grow--open', !was); btn.setAttribute('aria-expanded', was ? 'false' : 'true');
      var d = art.querySelector('.lf-gdetail'); if (d) d.remove();
      if (!was) art.appendChild(detail(it));
      syncURL();
    });
    art.appendChild(btn);
    if (open) art.appendChild(detail(it));
    return art;
  }


  /* ---------- share / download one entry (2026-09-30) ----------
     Mirrors the Live Free Daily: a square card rendered on a canvas, offered to
     the native share sheet when the device has one and downloaded otherwise.
     Nothing leaves the page except what the reader chooses to send. */
  var GWORDMARK = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.0828 41.9558"><g fill="#E8E9C9"><path d="M25.5128,35.5097H7.2748V3.2231c0-1.7776-1.4455-3.2231-3.2226-3.2231h-.8296C1.4455,0,0,1.4455,0,3.2231v35.5092c0,1.7771,1.4455,3.2235,3.2226,3.2235h22.2902c1.7771,0,3.2226-1.4464,3.2226-3.2235s-1.4455-3.2226-3.2226-3.2226Z"/><path d="M39.4184,0h.8278C42.025,0,43.4692,1.4442,43.4692,3.2231v35.511c0,1.7781-1.4436,3.2217-3.2217,3.2217h-.8305c-1.7781,0-3.2217-1.4436-3.2217-3.2217V3.2231C36.1953,1.4442,37.6395,0,39.4184,0Z"/><path d="M84.8887,0h-.843c-1.3615,0-2.5826.8626-3.0385,2.1472l-10.9051,30.7919L59.1971,2.1468c-.455-1.2841-1.6761-2.1468-3.0385-2.1468h-.8421c-1.0584,0-2.0498.5198-2.6505,1.391-.6025.8702-.7384,1.981-.3638,2.9719l13.4242,35.5092c.4711,1.2461,1.6824,2.0838,3.0143,2.0838h2.7211c1.3329,0,2.5441-.8376,3.0143-2.0838l13.426-35.5092c.3746-.9909.2387-2.1016-.3638-2.9719-.6007-.8711-1.5912-1.391-2.6496-1.391Z"/><path d="M122.2479,6.4457c1.7762,0,3.2217-1.4459,3.2217-3.2226,0-1.7776-1.4455-3.2231-3.2217-3.2231h-22.2911c-1.7762,0-3.2217,1.4455-3.2217,3.2231v35.5092c0,1.7771,1.4455,3.2235,3.2217,3.2235h22.2911c1.7762,0,3.2217-1.4464,3.2217-3.2235s-1.4455-3.2226-3.2217-3.2226h-18.2371v-11.3091h16.3572c1.7762,0,3.2217-1.4459,3.2217-3.2226s-1.4455-3.2226-3.2217-3.2226h-16.3572V6.4457h18.2371Z"/><path d="M180.5993,0h-22.2902c-1.7771,0-3.2226,1.4455-3.2226,3.2231v35.5092c0,1.7771,1.4455,3.2235,3.2226,3.2235h.8314c1.7771,0,3.2226-1.4464,3.2226-3.2235v-14.5318h16.3572c1.7762,0,3.2217-1.4459,3.2217-3.2226s-1.4455-3.2226-3.2217-3.2226h-16.3572V6.4457h18.2362c1.7771,0,3.2226-1.4459,3.2226-3.2226,0-1.7776-1.4455-3.2231-3.2226-3.2231Z"/><path d="M305.9565,28.6769c-5.2078,4.9113-14.5514,7.7316-21.2329,4.1715-.1595-.0849-.302-.1895-.4566-.2807,7.9037-3.7027,14.5206-10.5274,14.8113-19.6325.4025-12.574-13.8364-16.1815-22.1116-8.2604-6.4961,6.2186-7.9269,16.2544-4.5834,24.306-.2768.3883-.4115.5483-.8401.9435-5.1179,4.3552-16.877,5.984-23.2142,3.5261-.5669-.2199-1.1042-.4832-1.6191-.7759,1.6985-.7531,3.3358-1.7119,4.8861-2.9915,4.3003-3.5476,8.3827-8.5192,9.5705-14.0803,1.2327-5.7726-1.5664-11.9224-6.9737-14.4719-4.9781-2.3466-10.6207-.346-14.5613,3.0635-7.1964,6.228-8.647,16.2334-5.1994,24.4468-.091.0134.5447,1.2618,1.3455,2.6501-4.4463,3.4412-10.2979,4.2936-14.7668,2.035-2.3615-1.1934-5.4859-5.8074-7.5261-9.5901l.6431-.0295c1.1014-.2043,2.1262-.5466,3.0605-1.0209,1.2355-.628,2.3093-1.4638,3.1908-2.4838.8826-1.0191,1.5689-2.2295,2.0367-3.5963.465-1.3543.7006-2.8601.7006-4.4777,0-1.8048-.2845-3.4591-.8468-4.9166-.5669-1.4625-1.3796-2.7399-2.4178-3.7965-1.0393-1.0598-2.3107-1.8853-3.777-2.4521-1.4558-.5618-3.072-.8488-4.806-.8488h-16.3728c-1.7139,0-3.1075,1.395-3.1075,3.1091v35.5092c0,1.7137,1.3936,3.1086,3.1075,3.1086h.8316c1.714,0,3.1075-1.395,3.1075-3.1086v-14.6462h6.4079c2.2418,4.5836,6.1174,11.365,9.2471,13.6003,8.6919,6.2088,17.9509,4.6976,25.7236-.9802.1915.1703.3752.3473.5739.5109,8.9469,7.3495,27.1661,5.0543,35.5356-2.0547.5913.6378,1.2229,1.2452,1.905,1.808,9.4898,7.8246,24.3679,4.6221,32.7443-3.278,3.3274-3.1377-1.6949-8.1477-5.0161-5.0154ZM210.2179,17.8693h-11.3825V6.3313h11.3825c1.7799,0,3.1419.5127,4.1616,1.5653,1.0262,1.0598,1.5242,2.4436,1.5242,4.2314,0,1.7861-.4966,3.1609-1.52,4.2001-1.021,1.037-2.3833,1.5411-4.1657,1.5411ZM241.5393,27.1858c-2.6382-5.0378-2.4914-11.6564,1.2251-16.1082,2.1937-2.6277,6.404-5.4713,9.5432-2.7287,3.6659,3.203,1.6759,7.8156-.7201,11.1022-2.384,3.2691-5.5428,6.1802-9.4013,7.5323-.2135.0746-.4313.1336-.647.2025ZM280.0294,12.0073c1.9955-2.9732,6.2305-6.3492,9.9244-4.0562,2.4664,1.53,2.2865,5.023,1.6044,7.4549-1.6506,5.8937-6.7447,9.5973-12.2994,11.5988-2.2724-4.6887-2.1291-10.6771.7706-14.9975Z"/><path d="M323.7207,29.0988c-2.9607,0-5.3609,2.4002-5.3609,5.3618s2.4002,5.3609,5.3609,5.3609,5.362-2.4002,5.362-5.3609-2.4007-5.3618-5.362-5.3618Z"/></g></svg>');

  var GVCOL = {
    'we-look-for-this': ['#E8E9C9', '#4A2E45'],
    'cleaner-choice':   ['#BFD46A', '#4A2E45'],
    'allowed':          ['#DCB6D6', '#4A2E45'],
    'safe-comedogenic': ['#88C8EE', '#4A2E45'],
    'depends-on-dose':  ['#BF8637', '#4A2E45'],
    'never-allowed':    ['#F15641', '#E8E9C9']
  };

  function entryUrl(it) { return '/pages/ingredients/' + it.h; }
  function entryHref(it) { return location.origin + entryUrl(it); }

  function gwrap(ctx, text, maxW) {
    var words = String(text || '').split(/\s+/), lines = [], line = '';
    words.forEach(function (w) {
      var t = line ? line + ' ' + w : w;
      if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w; } else { line = t; }
    });
    if (line) lines.push(line);
    return lines;
  }

  function entryPng(it) {
    return Promise.all([
      document.fonts.load('600 60px "Instrument Sans"'),
      document.fonts.load('400 34px Jost')
    ]).catch(function () {}).then(function () {
      return new Promise(function (resolve) {
        var S = 1080, k = S / 340, c = document.createElement('canvas');
        c.width = S; c.height = S;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#4A2E45'; ctx.fillRect(0, 0, S, S);
        var pair = GVCOL[it.v] || ['#E8E9C9', '#4A2E45'];
        ctx.fillStyle = pair[0]; ctx.fillRect(0, 0, S, 14 * k);

        var pad = 34 * k, maxW = S - pad * 2, y = pad + 54 * k;
        ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';

        ctx.fillStyle = pair[0];
        ctx.font = '700 ' + (11 * k) + 'px Jost';
        try { ctx.letterSpacing = (11 * k * .14) + 'px'; } catch (e) {}
        ctx.fillText(String(VERD[it.v] || it.v || '').toUpperCase(), pad, y);
        try { ctx.letterSpacing = '0px'; } catch (e) {}
        y += 30 * k;

        ctx.fillStyle = '#E8E9C9';
        ctx.font = '600 ' + (30 * k) + 'px "Instrument Sans", Jost, sans-serif';
        gwrap(ctx, it.n, maxW).slice(0, 3).forEach(function (ln) { ctx.fillText(ln, pad, y); y += 34 * k; });

        if (it.w) {
          y += 14 * k;
          ctx.fillStyle = 'rgba(232,233,201,.80)';
          ctx.font = '400 ' + (14 * k) + 'px Jost';
          gwrap(ctx, it.w, maxW).slice(0, 6).forEach(function (ln) { ctx.fillText(ln, pad, y); y += 21 * k; });
        }

        var img = new Image();
        var finish = function () { c.toBlob(function (b) { resolve(b); }, 'image/png'); };
        img.onload = function () {
          var w = 150 * k, hh = w * 41.9558 / 329.0828, by = S - pad;
          ctx.fillStyle = 'rgba(232,233,201,.75)';
          ctx.font = '400 ' + (10.5 * k) + 'px Jost';
          try { ctx.letterSpacing = (10.5 * k * .12) + 'px'; } catch (e) {}
          ctx.fillText('LIVEFREESKINCARE.COM', pad, by);
          try { ctx.letterSpacing = '0px'; } catch (e) {}
          ctx.drawImage(img, pad, by - 10.5 * k - 8 * k - hh, w, hh);
          finish();
        };
        img.onerror = finish; img.src = GWORDMARK;
      });
    });
  }

  function shareRow(it) {
    /* D is local to detail(); take our own reference or this throws and the
       whole detail panel silently fails to render. */
    var D = (T && T.defs) || {};
    var row = h('div', 'lf-gshare');
    var msg = h('p', 'lf-gshare__msg'); msg.hidden = true;
    var say = function (t) { msg.textContent = t; msg.hidden = false; };

    var sBtn = h('button', 'lf-gshare__btn', (D.share || 'share'));
    sBtn.type = 'button';
    sBtn.addEventListener('click', function () {
      var payload = { title: it.n, text: it.n + ' - ' + (it.w || ''), url: entryHref(it) };
      if (navigator.share) {
        navigator.share(payload).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(entryHref(it)).then(
          function () { say(D.copied || 'link copied'); },
          function () { say(entryHref(it)); }
        );
      } else { say(entryHref(it)); }
    });

    var dBtn = h('button', 'lf-gshare__btn lf-gshare__btn--ghost', (D.download || 'download card'));
    dBtn.type = 'button';
    dBtn.addEventListener('click', function () {
      dBtn.disabled = true;
      entryPng(it).then(function (blob) {
        dBtn.disabled = false;
        if (!blob) { say(D.failed || 'could not build the card'); return; }
        var file = null;
        try { file = new File([blob], it.h + '.png', { type: 'image/png' }); } catch (e) {}
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: it.n }).catch(function () {});
          return;
        }
        var u = URL.createObjectURL(blob), a = document.createElement('a');
        a.href = u; a.download = it.h + '.png';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(u); }, 4000);
        say(D.saved || 'saved');
      }, function () { dBtn.disabled = false; say(D.failed || 'could not build the card'); });
    });

    row.appendChild(sBtn); row.appendChild(dBtn); row.appendChild(msg);
    return row;
  }

  function poreText(risk) {
    var base = T.pore[risk]; if (!base) return '';
    return base + ' ' + T.pore.scope;
  }
  function defs(pairs) {
    var dl = h('dl', 'lf-gdefs');
    pairs.forEach(function (p) {
      if (!p[1] || !String(p[1]).trim()) return;
      var d = h('div', 'lf-gdef'); d.appendChild(h('dt', null, p[0])); d.appendChild(h('dd', null, String(p[1]).trim())); dl.appendChild(d);
    });
    return dl.children.length ? dl : null;
  }
  function callout(k, body, rule) { var c = h('div', 'lf-gcall' + (rule ? ' lf-gcall--rule' : '')); c.appendChild(h('p', 'lf-gcall__k', k)); c.appendChild(h('p', 'lf-gcall__p', body)); return c; }
  function detail(it) {
    var d = h('div', 'lf-gdetail'), D = T.defs;
    var a = defs([[D.what, it.w], [D.does, it.f.join(', ')], [D.take, it.t], [D.look, it.c], [D.part, it.pc], [D.age, it.b.join(' · ')], [D.best, it.g.join(' · ')], [D.skin, it.s.join(' · ')], [D.pore, poreText(it.pr)], [D.pairs, it.pw]]);
    if (a) d.appendChild(a);
    if (it.st) d.appendChild(callout(D.stacking, it.st));
    var lhWord = { banned: 'Banned', conditional: 'Conditional', allowed: 'Allowed' }[it.lh];
    var b = defs([[D.instead, it.ui], [D.other, lhWord ? fmt(T.otherStandard, { w: lhWord }) : ''], [D.scope, it.sn]]);
    if (b) d.appendChild(b);
    if (it.wd) d.appendChild(callout(D.disagree, it.wd, true));
    if (it.p.length) {
      var pw = h('div', 'lf-gfind');
      pw.appendChild(h('p', 'lf-gfacet__label', D.findin));
      var pr = h('div', 'lf-gprods');
      it.p.forEach(function (p) { var a2 = h('a', 'lf-gprod'); a2.href = p.u; a2.appendChild(h('span', 'lf-gprod__n', p.n)); if (p.v) a2.appendChild(h('span', 'lf-gprod__v', p.v)); pr.appendChild(a2); });
      pw.appendChild(pr); d.appendChild(pw);
    }
    var src = h('div', 'lf-gsrc'); src.appendChild(h('span', null, (it.src && it.src[0]) || T.sourceFallback));
    /* Every entry ships u:"" in the index, so the old `if (it.u)` test was never
       true and "open this entry" has never rendered. The route is derived from
       the handle, which every entry has. (2026-09-30) */
    var o = h('a', 'lf-gsrc__open', (D.open || 'open this entry') + ' →'); o.href = entryUrl(it); src.appendChild(o);
    d.appendChild(src);
    d.appendChild(shareRow(it));
    return d;
  }

  /* ---------- label checker ---------- */
  function parseLabel(text) {
    return String(text || '').replace(/\r/g, '\n').split(/[,\n;]/)
      .map(function (t) { return t.replace(/\([^)]*\)/g, ' ').replace(/[\*†‡\.]+/g, ' ').trim(); })
      .filter(function (t) { return t.length > 1; });
  }
  function matchToken(tok) {
    var items = S.data, n = norm(tok); if (!n) return null;
    for (var i = 0; i < items.length; i++) { var it = items[i], k = it._norms.indexOf(n); if (k > -1) return { it: it, as: k === 0 ? null : (it.a[k - 1] || tok) }; }
    if (n.length >= 6) {
      for (var j = 0; j < items.length; j++) {
        var it2 = items[j];
        for (var m = 0; m < it2._norms.length; m++) { var cand = it2._norms[m]; if (cand.length >= 6 && (n.indexOf(cand) > -1 || cand.indexOf(n) > -1)) return { it: it2, as: m === 0 ? it2.n : it2.a[m - 1] }; }
      }
    }
    return null;
  }
  function renderCheck() {
    var C = T.check, tokens = parseLabel(el.label.value), hits = [], seen = {};
    if (!S.data) { el.vhead.textContent = C.idle; return; }
    tokens.forEach(function (tok, i) { var m = matchToken(tok); if (!m || seen[m.it._h]) return; seen[m.it._h] = true; hits.push({ it: m.it, as: m.as, pos: i + 1 }); });
    hits.sort(function (a, b) { return (ORDER.indexOf(a.it.v) - ORDER.indexOf(b.it.v)) || a.pos - b.pos; });
    var nNever = hits.filter(function (x) { return x.it.v === 'never-allowed'; }).length;
    var nPore = hits.filter(function (x) { return x.it.pr === 'mod' || x.it.pr === 'high'; }).length;
    var nLove = hits.filter(function (x) { return POSITIVE[x.it.v]; }).length;
    var total = tokens.length, head = C.idle, sub = null, box = 'allowed';
    if (total && !hits.length) head = C.nomatch;
    else if (nNever) { head = nNever === 1 ? C.never1 : fmt(C.neverN, { n: nNever }); sub = C.neverSub; box = 'never-allowed'; }
    else if (nPore) { head = fmt(C.pore, { n: nPore, s: nPore === 1 ? 'ingredient' : 'ingredients' }); sub = C.poreSub; box = 'safe-comedogenic'; }
    else if (hits.length) { head = C.clear; sub = nLove ? (nLove === 1 ? C.love1 : fmt(C.loveN, { n: nLove })) : null; box = 'we-look-for-this'; }
    el.vbox.className = 'lf-gverdict lf-gverdict--' + box;
    el.vhead.textContent = head; el.vsub.textContent = sub || ''; el.vsub.hidden = !sub;
    var frag = document.createDocumentFragment();
    hits.forEach(function (x) {
      var r = h('div', 'lf-gcrow lf-grow--' + x.it.v + (x.pos <= 5 ? ' lf-gcrow--high' : ''));
      var top = h('div', 'lf-gcrow__top');
      var pos = h('span', 'lf-gcrow__pos'); pos.appendChild(h('span', 'lf-gcrow__num', String(x.pos))); pos.appendChild(h('span', 'lf-gcrow__of', fmt(C.of, { n: total }))); top.appendChild(pos);
      top.appendChild(h('span', 'lf-gcrow__name', x.it.n)); top.appendChild(chip(x.it.v, 'sm')); r.appendChild(top);
      if (x.it.w) r.appendChild(h('p', 'lf-gcrow__desc', x.it.w));
      if (x.as) r.appendChild(h('p', 'lf-gcrow__as', fmt(C.matched, { a: x.as })));
      frag.appendChild(r);
    });
    el.crows.textContent = ''; el.crows.appendChild(frag); el.crows.hidden = !hits.length;
    el.cempty.hidden = !(total > 0 && !hits.length);
    var un = total - hits.length;
    el.cunmatched.hidden = !(un > 0 && hits.length);
    el.cunmatched.textContent = un === 1 ? C.unmatched1 : fmt(C.unmatchedN, { n: un });
  }

  /* ---------- tabs and URL ---------- */
  function setMode(mode) {
    S.mode = mode;
    Array.prototype.forEach.call(el.tabs, function (t) { var on = t.getAttribute('data-lf-tab') === mode; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    Array.prototype.forEach.call(el.panels, function (p) { p.hidden = p.getAttribute('data-lf-panel') !== mode; });
    if (mode === 'check') load().then(renderCheck);
    syncURL();
  }
  function syncURL() {
    var p = new URLSearchParams();
    if (S.q) p.set('q', S.q);
    Object.keys(S.sel).forEach(function (k) { if (S.sel[k].length) p.set(k, S.sel[k].join(',')); });
    if (S.mode === 'check') p.set('mode', 'check');
    if (S.open) p.set('entry', S.open);
    var qs = p.toString();
    try { history.replaceState(null, '', qs ? '?' + qs : location.pathname); } catch (e) {}
  }
  function readURL() {
    var p = new URLSearchParams(location.search);
    var list = function (k) { return (p.get(k) || '').split(',').map(trim).filter(Boolean); };
    S.sel = { verdict: list('verdict'), function: list('function'), good: list('good'), skin: list('skin'), age: list('age'), more: list('more') };
    S.q = p.get('q') || ''; el.q.value = S.q;
    if (p.get('mode') === 'check') setMode('check');
    if (anyFilter() || p.get('entry')) load();
  }

  /* ---------- wiring ---------- */
  Array.prototype.forEach.call(el.tabs, function (t) {
    t.addEventListener('click', function () { setMode(t.getAttribute('data-lf-tab')); });
    t.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = t.getAttribute('data-lf-tab') === 'browse' ? 'check' : 'browse'; setMode(n); root.querySelector('[data-lf-tab="' + n + '"]').focus(); } });
  });
  el.q.addEventListener('focus', function () { load(); }, { once: true });
  el.q.addEventListener('input', debounce(function () { S.q = el.q.value; load().then(renderBrowse); }, 120));
  el.clear.addEventListener('click', function () { S.q = ''; el.q.value = ''; S.sel = { verdict: [], function: [], good: [], skin: [], age: [], more: [] }; renderBrowse(); });
  el.list.addEventListener('click', function (e) {
    // a server-rendered row was tapped before the data arrived: load, then open it in place
    if (S.data) return;
    var a = e.target.closest('a.lf-grow__btn'); if (!a) return;
    e.preventDefault(); var href = a.getAttribute('href') || ''; var hnd = href.split('/').pop();
    load().then(function () { if (S.data) { var hit = S.data.filter(function (x) { return x._h === hnd; })[0]; if (hit) { S.open = hit._h; renderBrowse(); var o = el.list.querySelector('.lf-grow--open'); if (o) o.scrollIntoView({ block: 'nearest' }); } } });
  }, { once: false });
  el.label.addEventListener('input', debounce(renderCheck, 150));
  el.labelClear.addEventListener('click', function () { el.label.value = ''; renderCheck(); });
  el.labelReset.addEventListener('click', function () { el.label.value = EXAMPLE; renderCheck(); });

  readURL();

  // idle prefetch: only when the section allows it and the connection is not metered or slow
  if (root.getAttribute('data-lf-prefetch') === 'true' && !S.data && !S.loading) {
    var c = navigator.connection || {};
    var slow = c.saveData || /(^|-)2g$/.test(c.effectiveType || '') || c.effectiveType === '3g';
    if (!slow) {
      var go = function () { setTimeout(load, 1200); };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 }); else go();
    }
  }
})();